import {toast} from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import transactionIcon from "/public/images/transaction.svg"
import {
    Loader,
    Modal,
    Button,
    ButtonToolbar,
} from "rsuite";
import {useEffect, useState} from 'react';
import AuthService from "../../../services/auth.service";
import axios from "axios";
import './subscription.scss';
import UserMeal from "../user_meal/userMeal";
import UserFormUpdate
    from "../elements/user_form_update/userFormUpdate";
import HttpService from "../../../services/HttpService";

const APP_URL = process.env.APP_URL;

const Subscription = (props) => {
    const [transactions, setTransactions] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [activeTabContent, setActiveTabContent] = useState(null);
    const {setContent} = props;
    const [size, setSize] = useState();
    const [open, setOpen] = useState(false);
    const handleOpen = value => {
        setSize(value);
        setOpen(true)
        HttpService.get(`${APP_URL}/api/gateway-transactions`).then(response => {
            const transactions = response.data.data
            let data = transactions.map((transaction, index) => (
                <div className="transactions">
                    <div className="icon">
                        <img src={transaction.image} alt="تراکنش کاربر"/>
                    </div>
                    <div className="item">
                        <div className="title">
                            <div>{transaction.title}</div>
                            <div>{transaction.amount} تومان</div>
                        </div>
                        <div className="date">{transaction.updated_at}</div>
                        <div className="follow-up">{trackingCode(transaction)}</div>
                    </div>
                </div>
            ));
            setTransactions(data);
        })
    };
    const handleClose = () => setOpen(false);
    const tabs = [{
        title: 'رژیم های فعال',
        params: {expired: false}
    }, {
        title: 'رژیم های قبلی',
        params: {expired: true}
    },];

    useEffect(() => {
        sync(activeTab);
    }, []);

    return (<>
        <UserFormUpdate/>
        <div className="d-flex justify-content-between">
            <div className=" text-bold" style={{fontSize: '1rem'}}>
                رژیم های من
            </div>

             <ButtonToolbar>
        <Button size="xs" onClick={() => handleOpen('xs')} className="transaction-button">
                <div className="d-flex align-items-center">
                    <div className="img">
                        <img src={transactionIcon} alt="تراکنش های کاربر"/>
                    </div>
                    <div className="text"> تراکنش ها</div>
                </div>
        </Button>
          </ButtonToolbar>
        </div>
        <Modal className={'transaction-modal'} open={open} onClose={handleClose}>
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <strong className="transaction-title">سوابق خرید</strong>
            <div className="transactions-container">

            {transactions ? transactions : (<>
                        <Loader backdrop content="درحال دریافت اطلاعات ..." vertical/></>)}
            </div>
        </Modal.Body>
      </Modal>
        <div className="tabs-container" style={{marginTop: '2rem'}}>
            <div className="tabs subscription-tabs">
                {tabs.map((tab, tabIndex) =>
                    <div className={`tab ${activeTab === tabIndex ? 'active-tab' : ''}`}
                         key={tabIndex}
                         onClick={e => changeTab(tabIndex)}>
                        <div className="tab-title">{tab.title}</div>
                        <div className="tab-line"></div>
                    </div>)}
            </div>

            <div className="tab-content">
                <div className="card tab-content-card">
                    {activeTabContent ? render() : (<>
                        <Loader backdrop content="درحال دریافت اطلاعات ..." vertical/></>)}
                </div>
            </div>
        </div>
    </>);

    function render() {
        if (activeTabContent.length === 0) {
            return (<>
                <div className="empty-data" style={{marginTop: '2rem'}}>
                    <p>اطلاعاتی یافت نشد!</p>
                </div>
            </>);
        }

        return (<>
            <div className="subscriptions">
                {activeTabContent.map((subscription, subscriptionIndex) => {
                    return (<div className="subscription"
                                 key={subscriptionIndex}>
                        <div className="subscription-header">
                            <div className="subscription-title" style={{backgroundColor: subscription.periods.length?'#25AF9E':'rgb(208,132,20)'}}>
                                {subscription?.regime_title}
                            </div>

                        </div>

                        <div className="subscription-periods">
                            {
                                subscription.periods.length ?
                                    subscription.periods.map((period, periodIndex) => {
                                        let processing = subscription.processing ?
                                            <div className="text-loading">{subscription.status_label}</div> : '';
                                        return (
                                            <div className="period" key={periodIndex}>
                                                <div className="title">{period.title}</div>
                                                <div>

                                                </div>
                                                <div className="period-content-div">
                                                    <div className="content ">{period.content}</div>
                                                    <div className="period-content">

                                                        <button
                                                            className={` btn-action ${!period.enabled || subscription.processing ? 'btn-disabled' : ''}`}>
                                                            {processing && period?.processing ? (
                                                                    <div className="text-loading">{subscription.status_label}</div>) :
                                                                period.need_user_form && !period.is_expired ?
                                                                    <span
                                                                        className={period.need_user_form && !period.is_next_period ? 'btn-link' : 'btn-grey'}
                                                                        onClick={(period.need_user_form && !period.is_next_period) ? redirectToNewWeight : showNextPeriodMessage}>دریافت برنامه جدید</span> : !period.is_next_period && !period.need_user_form && period.status == 2 ?
                                                                        <span>در حال آماده سازی رژیم جدید (زمان انتظار تا 5 دقیقه)</span> :
                                                                        <span
                                                                            className={`${period.is_expired ? 'period-content' : 'btn-link'}`}
                                                                            onClick={e => showUserMeal(subscription, period, periodIndex)}>مشاهده رژیم</span>}
                                                        </button>

                                                    </div>
                                                </div>

                                                {period.is_expired || period.expiration_text ?
                                                    <div className="expired-div">
                                                        {period.expiration_text &&(<span className="expired-text">{period.expiration_text}</span>)}
                                                        {(period.is_expired && period.need_user_form) ?
                                                            <span className='delayed-span'>
                                                                <span
                                                                    className='delayed-text '>تاخیر در وارد کردن اطلاعات</span>
                                                            </span> : ''
                                                        }
                                                    </div>
                                                    : ''}

                                            </div>);

                                    })
                                    :
                                    <div className="period">
                                        <div className="period-content-div">
                                            <div className="title">{subscription?.regime_title}</div>
                                            <div className="period-content">
                                                <button
                                                    className='btn-action'>
                                                    <span
                                                        onClick={AuthService && !AuthService.getSubscription() ? redirectToNewWeight:showNextPeriodMessage}
                                                        className={`${!AuthService.getSubscription() ? 'btn-link' : 'btn-grey'}`}
                                                    >
                                                        {AuthService && !AuthService.getSubscription() ?
                                                            'دریافت برنامه جدید'
                                                            :
                                                        'مشاهده رژیم'
                                                        }
                                                        </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>


                            }
                        </div>
                    </div>);
                })}
            </div>
        </>);
    }

    function trackingCode(transaction) {
        return transaction.transaction_status == 2 ? `کد پیگیری : ${transaction.tracking_code}` : transaction.description
    }

    function getIcon(status) {
        if (status == 2) {
            return <img src={transactionSuccessIcon} alt="تراکنش موفق"/>;
        } else {
            return <img src={transactionFailedIcon} alt="تراکنش ناموفق"/>;
        }

    }

    function redirectToNewWeight() {
        window.location.replace('/weighing');
    }

    function changeTab(tabIndex) {
        setActiveTab(tabIndex);
        setActiveTabContent(null);
        sync(tabIndex);
    }

    function showUserMeal(subscription, period, periodIndex) {

        if (subscription.processing && period.processing) {
            return false;
        }
        if (period.is_expired && period.need_user_form) {
            toast.warn('به دلیل وارد نکردن اطلاعات در زمان مقرر، رژیم این دوره صادر نشد.', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return false;

        }
        if (!period.enabled && !period.need_user_form && !period.is_expired) {
            //if (!period.enabled) {
            toast.warn('رژیم دوره جدید پس از اتمام دوره جاری با وزن کشی جدید و اطلاعات جدید شما آماده می شود', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // return false;
        }
        window.location.href = `/subscriptions/${subscription.id}/periods/${periodIndex}`

    }

    function sync(tabIndex, hasLoading = true) {
        let config = {
            headers: {Authorization: `Bearer ${AuthService.getAccessToken()}`}
        };

        const currentTab = tabs[tabIndex];
        config.params = currentTab.params;

        if (hasLoading) {
            setIsLoading(true);
        }
        axios.get(`${APP_URL}/api/v3/subscriptions`, config)
            .then(function (response) {
                setActiveTabContent(response.data.result);
                if (hasLoading) {
                    setIsLoading(false);
                }

                setTimeout(() => {
                    sync(tabIndex, false);
                }, 120000);
            })
            .catch(function (error) {
                if (hasLoading) {
                    setIsLoading(false);
                }

                if (!error.response) {
                    // handleNotfound();
                    // toast.error('خطایی رخ داده است!', {
                    //     position: "top-right",
                    //     autoClose: 5000,
                    //     hideProgressBar: false,
                    //     closeOnClick: true,
                    //     pauseOnHover: true,
                    //     draggable: true,
                    //     progress: undefined,
                    //     theme: "light",
                    // });

                    return false;
                }

                const statusCode = error.response.status;
                switch (statusCode) {
                    case 422:
                        const {errors} = error.response.data;

                        for (const errorsKey in errors) {
                            const error = errors[errorsKey][0];

                            toast.error(error, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        }
                        break;

                    case 401:
                        AuthService.logout();
                        window.location.replace('/');
                        break;
                    default:
                        // handleNotfound();
                        // toast.error('خطایی رخ داده است!', {
                        //     position: "top-right",
                        //     autoClose: 5000,
                        //     hideProgressBar: false,
                        //     closeOnClick: true,
                        //     pauseOnHover: true,
                        //     draggable: true,
                        //     progress: undefined,
                        //     theme: "light",
                        // });
                        break;
                }
            });
    }

    function showNextPeriodMessage() {
        toast.warn('رژیم دوره جدید پس از اتمام دوره جاری با وزن کشی جدید و اطلاعات جدید شما آماده می شود', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }

    function handleNotfound() {

        localStorage.setItem("error", 'PageNotFound');
        setIsLoading(false);
        //setStep('notfound');
        window.location.href = '';
    }

}

export default Subscription;
